import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from 'angularx-social-login';
import {Globals} from './globals';

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";


@Injectable({
  providedIn: 'root'
})
export class AutorizacionService implements CanActivate {




  constructor(private authService: AuthService,public globals: Globals,private http: HttpClient) { }

  opcionesHttp = {
    headers: new HttpHeaders({
      "Content-Type": "application/json"
    })
  };

  consultarDatosUsuario(correousuario) {
    let Data = {
      correousuario
    };
    return this.http.post(`${environment.apiUrl}/Usuarios/consultarDatosUsuario`, Data);
  }

  consultarDatosUsuarioExterno(correousuario) {
    let Data = {
      correousuario
    };
    return this.http.post(`${environment.apiUrl}/Usuarios/consultarDatosUsuarioExterno`, Data);
  }

  enviarCorreoInicio(data) {

    return this.http.post(`${environment.apiUrl}/Usuarios/correoinicio`, data);
  }

  enviarCodigo(codigo) {
    let Data = {
      codigo
    };
    return this.http.post(`${environment.apiUrl}/Usuarios/validarCodigo`, Data);
  }


  canActivate() {
    let estado;

    estado = this.globals.EstaAuntenticado;

    // this.authService.authState.subscribe((user) => {
    //   if (user) {
    //     //////conole.log('Estás logueado');
    //     estado = true;

    //   }else{
    //     //////conole.log('No estás logueado');
    //     estado = false;
    //   }
    // });


    return estado;
}

}
